<template>
<div id="app" class="m-5" style="width: calc(100% - 6rem); border-radius: 20px;height: calc(100% - 6rem)">
  <!-- <f7-statusbar :theme="statusColor"></f7-statusbar> -->
  <left-panel v-if="connected" :context="context"></left-panel>
  <right-panel v-if="connected"></right-panel>
  <f7-views>
    <f7-view :domCache="false" :uniqueHistory="false" id="main-view" class="bgToolbox" main :url="url">
      <web-header v-if="connected && !isSmartphoneOS"
        :key="'web-header-' + webheaderKey"
        :context="context">
      </web-header>
      <mobile-header v-if="connected"
        :context="context">
      </mobile-header>
      <f7-pages :class="connected  ? 'marginHomepageLargeScreen': ''"></f7-pages>
    </f7-view>
  </f7-views>

  <cm-popups></cm-popups>

  <user-guide></user-guide>

</div>
</template>

<script>
// import LeftPanel from '@/components/leftpanel/CMLeftPanel.vue'
// import enrollMessage from '@/components/common/enrollMessage.vue'
// import FormDevis from '@/components/forms/CMDevis.vue'
// import FormReglament from '@/components/forms/CMReglament.vue'
// import dynamicStyleMixin from './mixins/dynamicStyleMixin'
// import {loadPage} from '@/helpers/routing'
import conf from './config/config.dev.js'

import WebHeader from '@/components/menus/WebHeader.vue'
import MobileHeader from '@/components/menus/MobileHeader.vue'
import LeftPanel from '@/components/menus/MobileLeftPanel.vue'
import RightPanel from '@/components/common/RightPanel.vue'

import designToolBox from '@/design/designToolBox.json'
import designDealprudence from '@/design/designDealprudence.json'

const flagTOOLBOX = conf.visual === 'TOOLBOX'

const design = flagTOOLBOX ? designToolBox : designDealprudence

import networkMixin from './mixins/networkMixin'

import CMPopup from '@/popups/Popups.vue'
import userGuidePopovers from '@/components/common/userGuidePopovers.vue'
// import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'

import {errorMessageAlert} from '@/helpers/alert'
import {loadPage, reloadPage} from '@/helpers/routing'

/* eslint-disable no-tabs */
/* eslint-disable indent */
export default {
  name: 'VOPDiamond',
  mixins: [networkMixin], //  dynamicStyleMixin],
  components: {
    // 'left-panel': LeftPanel,
    // 'cm-devis': FormDevis,
    // 'cm-reglament': FormReglament,
    // 'enroll-message': enrollMessage,
    // 'bottom-toolbar': bottomToolbar,
    'cm-popups': CMPopup,
    'left-panel': LeftPanel,
    'mobile-header': MobileHeader,
    'right-panel': RightPanel,
    'user-guide': userGuidePopovers,
    'web-header': WebHeader
  },
  data: () => {
    return {
      context: 'VOP',
      design: design,
      service: '',
      connected: false,
      flagTOOLBOX: conf.visual === 'TOOLBOX',
      homepageSelected: false,
      webheaderKey: false,
      defaultService: 'VOP',
      surveyConnectedMins: 0,
      surveyConnectedSecs: 10,
      url: ''
    }
  },
  created () {
    var data = this.getJsonFromUrl(window.location.href)
    if (data.OTP && data.email && data.ressource) {
      this.url = '/OTP/' + data.email + '/' + data.OTP + '/' + data.ressource
    } else if (data.sendDocumentsFromApplication === '1') {
      this.url = '/OTP/' + data.email + '/' + data.OTP + '/sendDocumentsFromApplication'
    } else if (data.loading === '1') {
      this.url = '/loading/'
    } else if (data.ResetPassword) {
      this.url = '/ResetPassword/' + (data.Token ? data.Token : '-1') + '/' + (data.Email ? data.Email : '-1')
    } else if (data.Token) {
      this.url = '/Register/' + (data.Token ? data.Token : '-1') + '/' + (data.Email ? data.Email : '-1')
    } else if (this.$engine.applicationMode === 'standard') {
      this.url = '/login/'
    } else {
      this.url = ''
    }
    /** TLV - TBR 27/11/2017
     * Affichage du menu de gauche seulement quand un service est actif,
     * Quand il n'y a pas de service sélectionné (sur la page de connexion par exemple),
     * Le menu de gauche n'est pas affiché
     */
    this.$bus.$on('service:change', () => {
      this.service = this.$engine.user.currentService.name
      this.$bus.$emit('refresh-cache-menu')
    })
    this.$bus.$on('refresh-cache-menu', () => {
      this.service = this.$engine.user.currentService.name
    })
    let that = this
    this.$bus.$on('reset-webheader', () => {
      that.webheaderKey = !that.webheaderKey
    })
    this.$bus.$off('reload-app')
    this.$bus.$on('reload-app', () => {
      that.$engine.setService(that.getContext())
      that.context = that.$engine.getService()
      that.webheaderKey = !that.webheaderKey
      that.$bus.$emit('reload-homepage')
      loadPage(that, {
        url: (flagTOOLBOX ? '/homecarrousel/' : '/home/') + that.context
      })
      that.$bus.$emit('reset-selected-menu')
    })
    this.$engine.getApiVersion()
    .then(resp => {
      if (resp.data.version) {
        that.$engine.versionAPI = resp.data.version
      }
    })
    .catch(err => {
      errorMessageAlert(err, that, true)
    })
  },
  mounted () {
    let that = this
    this.$bus.$on('login', function (login) {
      if (login) {
        // TLV 08/02/2021 : showing web header unless we are using an iframe
        if (login !== 'iframe') {
          that.connected = true
        }
        if (this.$engine.user.currentService.id != null) {
          this.$bus.emit('service:change', that.$engine.services.getServiceIdByName(that.defaultService))
        } else {
          this.$bus.emit('service:change', that.defaultService)
          this.$engine.user.currentService.name = that.defaultService
          this.$engine.user.currentService.id = this.$engine.services.getServiceIdByName(that.defaultService)
        }
      }
      if (that.$engine.user.getIsFirstLogin() === '1' || that.$engine.user.get().isFirstLogin === '1') {
        that.$bus.$emit('popup-change-password-data')
      }
    })
    this.$bus.$on('logout', function (force) {
      this.$bus.$emit('close-all-popups')
      this.$engine.auth.logout(force).then(response => {
        that.connected = false
        this.$engine.user.currentService.name = ''
        this.$bus.$emit('service:change', '')
        reloadPage(that, {
          url: '/login/',
          force: true,
          ignoreCache: true
        })
      })
    })
    this.$bus.$on('isOnHomepage', function (currentlyOnHomepage) {
      that.homepageSelected = currentlyOnHomepage
    })

    for (let key in this.cssVars) {
      document.documentElement.style.setProperty(key, this.cssVars[key])
    }
    this.surveyConnected()
  },
  computed: {

    cssVars () {
      return {
        // BOUTONS
        '--actionButtonSimpleGris': this.design.global.actionButtonSimpleGris,
        '--actionButtonColorBlue': this.design.global.actionButtonColorBlue,
        '--borderButtonColorBlue': this.design.global.borderButtonColorBlue,
        '--actionButtonColorViolet': this.design.global.actionButtonColorViolet,
        '--borderButtonColorViolet': this.design.global.borderButtonColorViolet,
        '--actionBackgroundColor':  this.design.global.actionBackgroundColor,
        '--actionBackgroundWhite':  this.design.global.actionBackgroundWhite,
        '--actionBackgroundBlue': this.design.global.actionBackgroundBlue,
        '--borderRadius': this.design.global.borderRadius,
        // TEXTE
        '--actionTextColorWhite': this.design.global.actionTextColorWhite,
        '--actionTextColorBlue': this.design.global.actionTextColorBlue,
        '--actionTextColorBlack': this.design.global.actionTextColorBlack,
        '--actionTextColorWhiteHover': this.design.global.actionTextColorWhiteHover,
        // POLICE
        '--fontFamily': this.design.global.fontFamily,
        '--fontSize': this.design.global.fontSize,
        '--fontSizetitle': this.design.global.fontSizetitle,
        '--fontSizeMenu': this.design.global.fontSizeMenu,
        '--fontSizeSubMenu': this.design.global.fontSizeSubMenu,
        '--fontWeightMenu': this.design.global.fontWeightMenu,
        '--fontWeight': this.design.global.fontWeight,
        '--borderRadius': this.design.global.borderRadius,
        // Couleur des tableaux et onglets actifs
        "--actionButtonSimpleGrisBleu": this.design.global.actionButtonSimpleGrisBleu,
        // header and nav menu
        "--headFamilyFont": this.design.menu.headFamilyFont,
        "--headbandColor": this.design.menu.headbandColor,
        "--headbandColorHover": this.design.menu.headbandColorHover,
        "--headbandColorHover2": this.design.menu.headbandColorHover2,
        "--headbandTextColor": this.design.menu.headbandTextColor,
        "--headbandTextColorHover": this.design.menu.headbandTextColorHover,
        "--headbandTextColorHover2": this.design.menu.headbandTextColorHover2,
        "--headbandLogoLong": this.design.menu.headbandLogoLong,
        "--homepageLogo": this.design.menu.homepageLogo,
        // popin login
        "--textLoginColor": this.design.login.textLoginColor,
        "--textButtonLoginColor": this.design.login.textButtonLoginColor,
        "--buttonLoginColor": this.design.login.buttonLoginColor,
        "--buttonLoginColorHover": this.design.login.buttonLoginColorHover,
        "--fontImage": this.design.login.fontImag,
        "--headbandLogoLong": this.design.login.headbandLogoLong,
        //acceuil
        "--cardFontSize": this.design.acceuil.cardFontSize,
        "--cardFontWeight": this.design.acceuil.cardFontWeight,
        "--cardBckgColor": this.design.acceuil.cardBckgColor,
        "--cardIconSize": this.design.acceuil.cardIconSize,
        "--cardIconWeight": this.design.acceuil.cardIconWeight,
        "--cardRadius": this.design.acceuil.cardRadius,
        "--cardFamilyFont": this.design.acceuil.cardFamilyFont,
        //Pages Title
        "--titleFamilyPage": this.design.Page.titleFamilyPage,
        "--titleSizePage": this.design.Page.titleSizePage,
        "--titleColorPage": this.design.Page.titleColorPage,
        "--titleWeightPage": this.design.Page.titleWeightPage,
        "--fontFamilyPage": this.design.Page.fontFamilyPage,
        "--fontSizePage": this.design.Page.fontSizePage,
        "--fontColorPage": this.design.Page.fontColorPage,
        "--fontWeightPage": this.design.Page.fontWeightPage
      }
    },
    isSmartphoneOS () {
      return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
    },
    statusColor () {
      if (this.online) return ''
      return 'red'
    },
    surveyConnectedTimer () {
      return ((this.surveyConnectedMins * 60) + this.surveyConnectedSecs) * 1000
    },
    titleNavBar () {
      let style = {
        'background-color': this.servicesColors.DEFAULT
      }
      if (!this.online) style['background-color'] = '#f44336'
      return style
    }
  },
  notifications: {
    showNetworkOffline: {
      type: 'error',
      title: '',
      message: 'Your device is offline'
    },
    showNetworkOnline: {
      type: 'info',
      title: '',
      message: 'Connection is now available'
    }
  },
  watch: {
    online (isOnline) {
      if (isOnline) {
        this.showNetworkOnline()
      } else {
        this.showNetworkOffline()
      }
    }
  },
  methods: {
    getJsonFromUrl (url) {
      if (!url) url = location.href
      var question = url.indexOf('?')
      var hash = url.indexOf('#')
      if (hash === -1 && question === -1) return {}
      if (hash === -1) hash = url.length
      var query = (question === -1 || hash === question + 1) ? url.substring(hash) : url.substring(question + 1, hash)
      var result = {}
      query.split('&').forEach(function (part) {
        if (!part) return
        part = part.split('+').join(' ') // replace every + with space, regexp-free version
        var eq = part.indexOf('=')
        var key = eq > -1 ? part.substr(0, eq) : part
        var val = eq > -1 ? decodeURIComponent(part.substr(eq + 1)) : ''
        var from = key.indexOf('[')
        if (from === -1) result[decodeURIComponent(key)] = val
        else {
          var to = key.indexOf(']', from)
          var index = decodeURIComponent(key.substring(from + 1, to))
          key = decodeURIComponent(key.substring(0, from))
          if (!result[key]) result[key] = []
          if (!index) result[key].push(val)
          else result[key][index] = val
        }
      })
      return result
    },
    surveyConnected () {
      let that = this
      setTimeout(function () {
        if (that.connected && that.$engine.common.network.isSessionExpired()) {
          that.$engine.user.manageSession()
          .then(resp => {
          })
          .catch(err => {
            errorMessageAlert(err, that, true)
          })
          .finally(() => {
            that.surveyConnected()
          })
        } else {
          that.surveyConnected()
        }
      }, that.surveyConnectedTimer)
    }
  }
}
</script>

<style media="screen">
.hiddenBlock {
  display: none;
}

@media (min-width: 850px) {
  .marginHomepageLargeScreen {
    top: calc(120px + 2rem); max-height: calc(100% - 120px);
  }
}

</style>
